module.exports = __webpack_public_path__ + "static/media/emojis_08.18b4ff47.svg";